"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropRegions = DropRegions;
var _react = _interopRequireDefault(require("react"));
var _core = require("@dnd-kit/core");
var _constants = require("../constants");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function DropRegions() {
  var _useDroppable = (0, _core.useDroppable)({
      id: _constants.Region.Expand
    }),
    active = _useDroppable.active,
    setExpandRegionNodeRef = _useDroppable.setNodeRef;
  var _useDroppable2 = (0, _core.useDroppable)({
      id: _constants.Region.Collapse
    }),
    setCollapseRegionRef = _useDroppable2.setNodeRef;
  if (!active) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledDragRegion, null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: setExpandRegionNodeRef
  }), /*#__PURE__*/_react["default"].createElement("div", {
    ref: setCollapseRegionRef
  }));
}
var StyledDragRegion = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tinset: 0;\n\tdisplay: grid;\n\tgrid-template-rows: 1.2fr 0.8fr;\n\tpointer-events: none;\n"])));